export var JobType;
(function (JobType) {
    JobType["ImportApi"] = "import-api";
    JobType["MergeCompanies"] = "merge-companies";
    JobType["ComputeDbStats"] = "compute-db-stats";
    JobType["ComputeDynamicStats"] = "compute-dynamic-stats";
    JobType["FileDeleteUnused"] = "file-delete-unused";
    JobType["PurgeExpiredTokens"] = "purge-expired-tokens";
    JobType["RefreshViews"] = "refresh-views";
    JobType["ImportRatings"] = "import-grades";
    JobType["ComputeHistoricStats"] = "compute-historic-stats";
    JobType["LinkCoveragesToInsistences"] = "link-coverages-to-insistences";
    JobType["LinkCoveragesToCoverRequests"] = "link-coverages-to-cover-requests";
    JobType["SendPassiveNotifications"] = "send-passive-notifications";
})(JobType || (JobType = {}));
